import { useContext } from 'react'
import { FormEnviroment } from '../../../../types'
import { DashboardContext } from '../../../../context'
import AppDataWrapper from '../../../../components/containers/AppDataWrapper'
import FormPlainEnviromentCurp from '../../../../components/form/FormPlainEnviromentCurp'
import FormPlainEnviromentData from '../../../../components/form/FormPlainEnviromentData'
import { Route, Routes, useResolvedPath } from 'react-router-dom'
import Error404 from '../../../../components/error/Error404'
import AmbientestModuleProvider from '../../../../context/AmbientestModuleContext'
import FormPlainEnviromentDocs from '../../../../components/form/FormPlainEnviromentDocs'

export default function ProfileEnviromentForm(props: Readonly<FormEnviroment>) {
    const dashboardContext = useContext(DashboardContext)
    const path = useResolvedPath("").pathname;

    return (<AppDataWrapper>
        <AmbientestModuleProvider formFields={props} path={path}>
            <Routes>
                <Route path="/" element={<FormPlainEnviromentCurp description={dashboardContext?.navBar.menuSelected?.description || ''} />} />
                <Route path="/datos" element={<FormPlainEnviromentData />} />
                <Route path="/documentos" element={<FormPlainEnviromentDocs />} />
                <Route path='*' element={<Error404 />} />
            </Routes>
        </AmbientestModuleProvider>
    </AppDataWrapper>

    )
}